import { render, staticRenderFns } from "./GlobalSwitchComponent.vue?vue&type=template&id=f8db54ba&scoped=true"
import script from "./GlobalSwitchComponent.vue?vue&type=script&lang=js"
export * from "./GlobalSwitchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8db54ba",
  null
  
)

export default component.exports